import { Model } from '@vuex-orm/core';
import Levelable from '@/models/Levelable';
import Option from '@/models/Option';
import Residence from '@/models/Residence';

export default class Level extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'levels';

  // List of all fields (schema) of the project model.
  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      // relationships
      options: this.morphedByMany(
        Option,
        Levelable,
        'level_id',
        'levelable_id',
        'levelable_type'
      ),
      residences: this.morphedByMany(
        Residence,
        Levelable,
        'level_id',
        'levelable_id',
        'levelable_type'
      ),
    };
  }

  static transformer(data) {
    const levels = [];
    data.data.forEach(item => {
      const level = {};
      level.id = item.id;
      level.name = item.name;
      level.slug = item.slug;
      level.count = item.count;
      level.description = item.description;
      levels.push(level);
    })
    return levels;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    //let url = '/wp-json/wp/v2/level?per_page=100';
    // Only fetch neccessary fields
    let url = '/wp-json/wp/v2/level?_fields=id,name,slug,count,description&per_page=100';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
